import { enable } from '../../../components/disable_form_on_submit'
import { show, hide } from '../../../util/show'
import { updateNavigationTopOffsetPropertyOnResize } from '../../../components/navigation_top_offset'
import i18n from '../../../i18n'
import { open } from '../../../components/modal'
import { asUTCDate, isoStringToDatetime, datetimeToString } from '../../../components/date_picker/date_helpers'

function getMessage() {
  return document.querySelector('.unpoly_wrapper').dataset.unsavedChangesWarning
}
up.compiler('.js-navigation_post_settings', element => {
  updateNavigationTopOffsetPropertyOnResize('mobile', element)
  updateNavigationTopOffsetPropertyOnResize('desktop', element)
})

up.compiler('.js-plan_for_paywall', el => {
  el.addEventListener('change', ev => {
    const plans = document.querySelectorAll('.js-plan_for_paywall')
    const checkedPlans = document.querySelectorAll('.js-plan_for_paywall:checked')
    const accessSentence = document.querySelector('.js-access__sentence')
    const noPlanSelectedError = document.querySelector('.js-no_plan_for_paywall_selected_error')

    if (plans.length === checkedPlans.length) {
      accessSentence.textContent = accessSentence.dataset.all
    } else {
      accessSentence.textContent = accessSentence.dataset.some
    }

    if (checkedPlans.length === 0) {
      show(noPlanSelectedError)
    } else {
      hide(noPlanSelectedError)
    }
  })
})

const distributeEmailCheckboxSelector = '.js-post_distribute_as_email_input'
up.compiler(distributeEmailCheckboxSelector, checkbox => {
  // disabling inputs prevents native client-side validations from running
  const toggleDisableOfNestedEmailSendingInputs = checkbox => {
    // only including from and reply to inputs because they're the only ones with validation,
    // and disabling more breaks using FormData on this form which is needed for the post email recipients summary
    const inputContainer = document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_inputs')
    const inputs = Array.from(inputContainer.querySelectorAll('input, select, textarea'))
    inputs.forEach(input => {
      if (checkbox.checked) {
        input.removeAttribute('disabled')
      } else {
        input.setAttribute('disabled', 'disabled')
      }
    })
  }

  toggleDisableOfNestedEmailSendingInputs(checkbox)

  up.on(checkbox, 'change', (event, checkbox) => {
    toggleDisableOfNestedEmailSendingInputs(checkbox)
  })
})

const setNoRecipientsSelectedErrorVisibility = () => {
  const checkedRecipients = document.querySelectorAll('.js-send_post_email_to_recipient:checked')
  const noRecipientsSelectedError = document.querySelector('.js-no_recipient_for_email_selected_error')

  if (checkedRecipients.length === 0) {
    show(noRecipientsSelectedError)
  } else {
    hide(noRecipientsSelectedError)
  }
}

up.compiler('.js-send_post_email_to_recipient', el => {
  el.addEventListener('change', setNoRecipientsSelectedErrorVisibility)
  return () => {
    el.removeEventListener('change', setNoRecipientsSelectedErrorVisibility)
  }
})

up.compiler('.js-teaser_image_input', el => {
  el.addEventListener(
    'change',
    ev => {
      const file = ev.target.files[0]

      if (!file) {
        return
      }

      const image = document.querySelector('.js-teaser_image')
      const reader = new FileReader()
      reader.onload = ev => image.style.setProperty('background-image', `url(${ev.target.result})`)
      image.classList.add('backend_post_settings_page__teaser_preview__image--has_image')
      reader.readAsDataURL(file)
      document.querySelector('#post_delete_teaser_image')?.remove()
    },
    false
  )
})

up.compiler('.js-teaser_image_upload', el => {
  el.addEventListener('click', ev => {
    document.querySelector('.js-teaser_image_input').click()
    ev.preventDefault()
    ev.stopPropagation()
  })
})

const publishLaterCheckboxSelector = '.js-post_publish_later'
up.compiler(publishLaterCheckboxSelector, el => {
  el.addEventListener('change', ev => {
    if (!ev.target.checked) {
      document.querySelector('#post_publish_at').value = ''
    }
  })
})

const formSelector = '.js-post_settings_form'
up.compiler('.js-teaser_image_delete', el => {
  el.addEventListener('click', ev => {
    const image = document.querySelector('.js-teaser_image')
    const imageInput = document.querySelector('.js-teaser_image_input')
    const form = document.querySelector(formSelector)

    image.classList.remove('backend_post_settings_page__teaser_preview__image--has_image')
    image.style.removeProperty('background-image')
    imageInput.value = ''

    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('id', 'post_delete_teaser_image')
    hiddenInput.setAttribute('name', 'post[delete_teaser_image]')
    hiddenInput.setAttribute('value', 'true')
    form.appendChild(hiddenInput)
  })
})

// if the teaser image was extracted from the post body, and the user did not
// pick a new teaser image, we replace the file input with a normal input
up.compiler(formSelector, el => {
  el.addEventListener('submit', ev => {
    if (hasUnsavedSenderChanges() && !confirm(getMessage())) {
      ev.preventDefault()
      ev.stopPropagation()
      enable(ev.target)
      return
    }

    const teaserImageInput = el.querySelector('#post_teaser_image')
    const fallback = teaserImageInput.dataset.fallback

    if (teaserImageInput.value === '' && fallback) {
      teaserImageInput.remove()
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'post[teaser_image]'
      input.value = fallback
      el.appendChild(input)
    }
  })
})

function hasUnsavedSenderChanges() {
  const from = document.querySelector('#post_post_email_distribution_from').value
  const replyTo = document.querySelector('#post_post_email_distribution_reply_to').value
  const fromLocal = document.querySelector('#post_post_email_distribution_from_local').value
  const replyToLocal = document.querySelector('#post_post_email_distribution_reply_to_local').value
  return from !== fromLocal || replyTo !== replyToLocal
}

const showSenderInputs = () => {
  const senderInputs = document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_inputs')
  const editButton = document.querySelector('.js-backend_post_settings_page__change_email_settings_edit')
  show(senderInputs)
  hide(editButton)
  return senderInputs
}

const hideSenderInputs = () => {
  const senderInputs = document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_inputs')
  const editButton = document.querySelector('.js-backend_post_settings_page__change_email_settings_edit')
  hide(senderInputs)
  show(editButton)
  return senderInputs
}

up.compiler('.js-backend_post_settings_page__test_email', function (element) {
  up.on(element, 'click', function (event) {
    const fromLocal = document.querySelector('#post_post_email_distribution_from_local')
    const replyToLocal = document.querySelector('#post_post_email_distribution_reply_to_local')

    if (!fromLocal.validity.valid || !replyToLocal.validity.valid) {
      showSenderInputs()

      fromLocal.reportValidity()
      replyToLocal.reportValidity()

      return
    }

    const url = element.dataset.url
    const form = document.querySelector(formSelector)
    const formData = new FormData(form)
    // Phoenix includes in the form a hidden field with the request's method.
    // The original form does a PUT, but here we need a POST, so this data needs to be removed.
    formData.delete('_method')
    const headers = {
      // do not set Content-Type for multipart/form-data so that the browser sets it with a correct boundary
    }

    const options = {
      url,
      params: formData,
      headers,
      method: 'post',
      failTarget: 'flash-alert'
    }

    up.navigate('flash-alert', options)
  })
})

up.compiler('.js-backend_post_settings_page__change_email_settings_apply', function (element) {
  up.on(element, 'click', function (event) {
    const from = document.querySelector('#post_post_email_distribution_from')
    const replyTo = document.querySelector('#post_post_email_distribution_reply_to')
    const fromLocal = document.querySelector('#post_post_email_distribution_from_local')
    const replyToLocal = document.querySelector('#post_post_email_distribution_reply_to_local')

    fromLocal.reportValidity()
    replyToLocal.reportValidity()

    if (fromLocal.validity.valid && replyToLocal.validity.valid) {
      hideSenderInputs()

      from.value = fromLocal.value
      replyTo.value = replyToLocal.value

      document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info_from').innerText =
        fromLocal.value
      document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info_reply_to').innerText =
        replyToLocal.value

      // the clicked button disappears on click so something else has to get focus,
      // otherwise SR users will be brought back to page start.
      document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info__lines').focus()
    }
  })
})

up.compiler('.js-backend_post_settings_page__change_email_settings_cancel', function (element) {
  up.on(element, 'click', function (event) {
    const from = document.querySelector('#post_post_email_distribution_from')
    const replyTo = document.querySelector('#post_post_email_distribution_reply_to')
    const fromLocal = document.querySelector('#post_post_email_distribution_from_local')
    const replyToLocal = document.querySelector('#post_post_email_distribution_reply_to_local')

    hideSenderInputs()

    fromLocal.value = from.value
    removeError(fromLocal.parentElement)

    replyToLocal.value = replyTo.value
    removeError(replyToLocal.parentElement)

    // the clicked button disappears on click so something else has to get focus,
    // otherwise SR users will be brought back to page start.
    document.querySelector('.js-backend_post_settings_page__change_email_settings_sender_info__lines').focus()
  })
})

up.compiler('#backend_post_settings_page__send_test_email', function (element) {
  up.on(element, 'change', function () {
    removeError(element.parentElement)
  })
})

up.compiler('#post_post_email_distribution_from_local', function (element) {
  up.on(element, 'invalid', function () {
    showSenderInputs()
    addError(element.parentElement, window.steadyI18n.errors.required)
  })

  up.on(element, 'change', function () {
    removeError(element.parentElement)
  })
})

up.compiler('#post_post_email_distribution_reply_to_local', function (element) {
  up.on(element, 'invalid', function () {
    showSenderInputs()
    addError(element.parentElement, window.steadyI18n.errors.invalidEmail)
  })

  up.on(element, 'change', function () {
    removeError(element.parentElement)
  })
})

up.compiler('.js-backend_post_settings_page__change_email_settings_edit', function (element) {
  up.on(element, 'click', function (event) {
    const senderInputs = showSenderInputs()
    // the clicked button disappears on click so something else has to get focus,
    // otherwise SR users will be brought back to page start.
    // setTimeout is necessary to give time for the senderInputs to appear on the page first
    setTimeout(() => {
      senderInputs.focus()
    }, 1)
  })

  const invalidInput = document.querySelector(
    '.js-backend_post_settings_page__change_email_settings_sender_inputs *[aria-invalid="true"]'
  )

  // if at least one of the hidden inputs has an error, reveal it
  if (invalidInput) {
    showSenderInputs()
  }
})

up.compiler('.js-backend_post_settings_page__change_email_settings_sender_inputs__from_local', element => {
  element.addEventListener('invalid', function (event) {
    if (event.target.validity.patternMismatch) {
      event.target.setCustomValidity(element.dataset.patternErrorMessage)
    }
  })

  element.addEventListener('change', function (event) {
    event.target.setCustomValidity('')
  })
})

const membersCheckboxSelector = '.js-send_post_email_to_members'
const singlePlanCheckboxSelector = '.js-post_email_plan'

up.compiler(membersCheckboxSelector, function (membersCheckbox) {
  const emailPlansCheckboxes = [...document.querySelectorAll(singlePlanCheckboxSelector)]

  const setMembersCheckboxState = () => {
    const checkedPlans = emailPlansCheckboxes.filter(el => el.checked)
    const membersCheckbox = document.querySelector(membersCheckboxSelector)
    const checked = checkedPlans.length > 0
    const indeterminate = checkedPlans.length > 0 && checkedPlans.length !== emailPlansCheckboxes.length
    membersCheckbox.checked = checked
    membersCheckbox.indeterminate = indeterminate
    setNoRecipientsSelectedErrorVisibility()
  }

  setMembersCheckboxState()

  const onChange = () => {
    const emailPlansCheckboxes = document.querySelectorAll(singlePlanCheckboxSelector)

    // uncheck all plans when membersCheckbox is unchecked
    emailPlansCheckboxes.forEach(el => {
      el.checked = membersCheckbox.checked
      setNoRecipientsSelectedErrorVisibility()
    })
  }

  membersCheckbox.addEventListener('change', onChange)
  emailPlansCheckboxes.forEach(emailPlansCheckbox => {
    emailPlansCheckbox.addEventListener('change', setMembersCheckboxState)
  })

  return () => {
    membersCheckbox.removeEventListener('change', onChange)
    emailPlansCheckboxes.forEach(emailPlansCheckbox =>
      emailPlansCheckbox.removeEventListener('change', setMembersCheckboxState)
    )
  }
})

// inputs on this page need their own calls to setCustomValidity
// and cannot rely on the page-wide calls from assets/js/components/input.js
// because they get validated NOT on submit, but
// on some other button press ("apply" and "send test email")
function addError(elem, error) {
  elem.classList.add('error')
  const input = elem.querySelector('input:not([type=hidden])')
  input.setCustomValidity(error)
}

function removeError(elem) {
  elem.classList.remove('error')
  const input = elem.querySelector('input:not([type=hidden])')
  input.setCustomValidity('')
}

const emailRecipientsSelector = '.js-post_email_recipients'
const sendToSubscribersCheckboxName = 'post[post_email_distribution][send_to_subscribers]'
const sendToMembersCheckboxName = 'post[post_email_distribution][send_to_members]'
const individualPlanCheckboxName = 'post[plans_for_email_ids][]'
up.compiler(emailRecipientsSelector, (element, { eligibleMemberCountPerPlan, eligibleSubscriberCount }) => {
  const memberCountPerPlanValue = JSON.parse(eligibleMemberCountPerPlan)
  const eligibleSubscriberCountValue = JSON.parse(eligibleSubscriberCount)

  const form = document.querySelector(formSelector)

  const countAndDisplayRecipients = () => {
    const formData = new FormData(form)
    const selectedPlans = formData.getAll(individualPlanCheckboxName)
    const memberCount = selectedPlans.reduce((acc, planId) => acc + memberCountPerPlanValue[planId], 0)
    element.dataset.memberCount = memberCount

    const sendToSubscribersValues = formData.getAll(sendToSubscribersCheckboxName)
    const subscriberCount = sendToSubscribersValues.includes('true') ? eligibleSubscriberCountValue : 0
    element.dataset.subscriberCount = subscriberCount

    const members = i18n.$ngettext('%{count} member', '%{count} members', memberCount, { count: memberCount })

    const subscribers = i18n.$ngettext(
      '%{count} newsletter subscriber',
      '%{count} newsletter subscribers',
      subscriberCount,
      { count: subscriberCount }
    )

    const count = i18n.$ngettext(
      'Your post will be sent to %{count} person (%{members}, %{subscribers}).',
      'Your post will be sent to %{count} people (%{members}, %{subscribers}).',
      memberCount + subscriberCount,
      { count: memberCount + subscriberCount, members, subscribers }
    )

    const notice = i18n.$gettext(
      'The actual number of recipients displayed in the post table may differ if members unsubscribe from the email list or if emails cannot be delivered.'
    )

    element.innerText = `${count} ${notice}`
  }

  countAndDisplayRecipients()

  up.on(form, 'change', event => {
    const target = event.target
    if (
      target.name === sendToSubscribersCheckboxName ||
      target.name === sendToMembersCheckboxName ||
      target.name === individualPlanCheckboxName
    ) {
      countAndDisplayRecipients()
    }
  })
})

const publishModalSelector = '.js-publish_confirm_modal'
const openPublishModalButtonSelector = '.js-open_publish_confirm_modal'
const publishModalTextSelector = '.js-publish_confirm_modal_text'
const publishModalButtonSelector = '.js-publish_confirm_modal_button'
const publishAtInputSelector = '.js-post_publish_at .js-date_picker_iso_date_value'
const svgAnimateSelector = publishModalSelector + ' #feather_rising'
up.compiler(openPublishModalButtonSelector, (button, { emailDistributed }) => {
  const modal = document.querySelector(publishModalSelector)
  const modalText = modal.querySelector(publishModalTextSelector)
  const modalButton = modal.querySelector(publishModalButtonSelector)
  const distributeEmailCheckbox = document.querySelector(distributeEmailCheckboxSelector)
  const publishLaterCheckbox = document.querySelector(publishLaterCheckboxSelector)

  if (emailDistributed === 'false' && modal && modalText && modalButton && distributeEmailCheckbox) {
    up.on(button, 'click', event => {
      if (!distributeEmailCheckbox.checked) {
        return
      }

      const countSpan = document.querySelector(emailRecipientsSelector)
      const memberCount = parseInt(countSpan.dataset.memberCount)
      const subscriberCount = parseInt(countSpan.dataset.subscriberCount)

      const publishAt = document.querySelector(publishAtInputSelector)?.value

      let timing = ''
      let buttonMessage = ''
      if (publishLaterCheckbox && publishLaterCheckbox.checked && publishAt) {
        const date = datetimeToString(asUTCDate(isoStringToDatetime(publishAt)))
        timing = i18n.$pgettext('[This post will be sent] on [11.10.2024 09:00]', 'on %{date}', { date })
        buttonMessage = i18n.$gettext('Schedule')
      } else {
        timing = i18n.$pgettext('[This post will be sent] immediately', 'immediately')
        buttonMessage = i18n.$gettext('Send')
      }

      const members = i18n.$ngettext('%{count} member', '%{count} members', memberCount, { count: memberCount })
      const subscribers = i18n.$ngettext(
        '%{count} newsletter subscriber',
        '%{count} newsletter subscribers',
        subscriberCount,
        {
          count: subscriberCount
        }
      )
      const message = i18n.$ngettext(
        'This post will be sent to %{count} person (%{x_members}, %{y_subscribers}) %{immediately_or_on_date}.',
        'This post will be sent to %{count} people (%{x_members}, %{y_subscribers}) %{immediately_or_on_date}.',
        memberCount + subscriberCount,
        {
          count: memberCount + subscriberCount,
          x_members: members,
          y_subscribers: subscribers,
          immediately_or_on_date: timing
        }
      )

      modalText.innerText = message
      modalButton.innerText = buttonMessage

      // we forcefully reload the SVG because of a bug in Chrome that doesn't trigger
      // all the animations after unpoly updates the form on failure
      const svg = document.querySelector(svgAnimateSelector).closest('svg')
      svg.replaceWith(svg.cloneNode(true))

      const svgAnimate = document.querySelector(svgAnimateSelector)
      svgAnimate.beginElement()
      open(modal)
      event.preventDefault()
    })
  }
})
